<img src="assets/img/moto-ai-beta-lockup.svg" alt="Moto AI Beta">
<div class="m-auto">
  <ng-lottie
    *ngIf="animationData"
    [options]="{ animationData: animationData }">
  </ng-lottie>
</div>
<div class="pt-5 text-left">
  <p [translate]="'app.download.getExclusiveAiFeature'" class="information-text pb-4"></p>
  <p [translate]="'app.download.afterInstallation'" class="information-text"></p>
</div>
<div class="flex m-auto pt-5">
  <button pButton class="w-full" (click)="redirectToGooglePlay()">
    <div class="flex w-full justify-content-center">
      <img src="assets/img/ic_download.svg" alt="Download icon" class="download-motoai-button-icon">
      <span [translate]="'app.download.downloadButton'" class="pl-2"></span>
    </div>
  </button>
</div>
<p [translate]="'app.download.availableVersions'" class="pt-3 available-version-text"></p>
